import React, { useMemo, useState } from "react";
import close from "../../assets/icons/close.svg";
import { Postdata } from "../../API/GlobalApi";
import Notifier from "../../Utils/notify";
import Session from "../../Utils/Sessions";
import '../../assets/css/Modal.css'
import { createPortal } from 'react-dom';
import ScheduledFeeShortDetails from "../../Pages/Manage_Fee_And_Accounts/StudentPaymentLedger/ScheduledFeeShortDetails";
import FeePlanShortDetails from "../../Pages/Manage_Fee_And_Accounts/StudentPaymentLedger/FeePlanShortDetails";
import { formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS_UTC, formatDateFeeDetailsDDMMYYYYHHMMSS, parseDDMMYYYYHHMMSS } from "../../Utils/data&dateTime";
import { downloadLedgerPDF, downloadPlanPDF, downloadScheduledPDF, printLedger, printPlan, printScheduledFee, shareFeeDetails, shareFeeDetailsPDF } from "../../Utils/LedgerUtilsFunctions";
import print from '../../assets/icons/print.svg';
import '../../assets/css/StudentShortDetails.css'
import { copyToClipboard } from "../../Utils/copyToClipboard";
export const StudentLedgerDetails = ({ isOpen, onClose, selectedFeeDetails }) => {

    const [visibleCount, setVisibleCount] = useState(50);
    const [viewMode, setViewMode] = useState("ledger");
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        onClose()
        setViewMode("ledger")
    }

    if (!isOpen) return null;

    return createPortal(
        <div className="modal-overlay" style={{ zIndex: 99999999 }}>
            <div
                className="modal-content studentLedgerReport studentledgerIndividual"
                style={{
                    position: "relative",
                    width: "70%",
                    display: "flex",
                    flexDirection: "column",
                    height: "84vh",
                    padding: 0,
                    overflow: "hidden",
                }}
            >

                {/* HEADER — fixed, never scrolls */}
                <div
                    className="modal-header-content"
                    style={{
                        flexShrink: 0,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "14px 20px",
                        background: "#fff",
                    }}
                >
                    <h2 className="text-primary" style={{
                        background: '#F9F9F9',
                        padding: '16px',
                        borderRadius: '8px',
                        textAlign: 'left',
                        fontWeight: 500,
                        fontSize: '18px',
                        color: "#222F3E",
                        display: 'flex',
                        flexDirection: '',
                        gap: '5px',
                        justifyContent: '',
                        width: '100%',

                    }} >
                        {selectedFeeDetails && `${selectedFeeDetails?.name?.toUpperCase()}`}

                        <span style={{ margin: "0 10px" }}>|</span>

                        <span
                            style={{ cursor: "pointer" }}
                            title="Copy Registration Number"
                            onClick={() =>
                                copyToClipboard(selectedFeeDetails.permanent_registration_number, "Reg No copied")
                            }
                        >
                            {selectedFeeDetails.permanent_registration_number} <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20"
                                height="20"><g id="SVGRepo_bgCarrier" strokeWidth="0"
                                > <title>Copy Reg .No </title>
                                </g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.24 2H11.3458C9.58159 1.99999 8.18418 1.99997 7.09054 2.1476C5.96501 2.29953 5.05402 2.61964 4.33559 3.34096C3.61717 4.06227 3.29833 4.97692 3.14701 6.10697C2.99997 7.205 2.99999 8.60802 3 10.3793V16.2169C3 17.725 3.91995 19.0174 5.22717 19.5592C5.15989 18.6498 5.15994 17.3737 5.16 16.312L5.16 11.3976L5.16 11.3024C5.15993 10.0207 5.15986 8.91644 5.27828 8.03211C5.40519 7.08438 5.69139 6.17592 6.4253 5.43906C7.15921 4.70219 8.06404 4.41485 9.00798 4.28743C9.88877 4.16854 10.9887 4.1686 12.2652 4.16867L12.36 4.16868H15.24L15.3348 4.16867C16.6113 4.1686 17.7088 4.16854 18.5896 4.28743C18.0627 2.94779 16.7616 2 15.24 2Z" fill="#7F56DA"></path> <path d="M6.6001 11.3974C6.6001 8.67119 6.6001 7.3081 7.44363 6.46118C8.28716 5.61426 9.64481 5.61426 12.3601 5.61426H15.2401C17.9554 5.61426 19.313 5.61426 20.1566 6.46118C21.0001 7.3081 21.0001 8.6712 21.0001 11.3974V16.2167C21.0001 18.9429 21.0001 20.306 20.1566 21.1529C19.313 21.9998 17.9554 21.9998 15.2401 21.9998H12.3601C9.64481 21.9998 8.28716 21.9998 7.44363 21.1529C6.6001 20.306 6.6001 18.9429 6.6001 16.2167V11.3974Z" fill="#7F56DA"
                                ></path> </g></svg>
                        </span>

                        <span style={{ margin: "0 10px" }}>|</span>

                        <span
                            style={{ cursor: "pointer" }}
                            title="Copy Contact Number"
                            onClick={() =>
                                copyToClipboard(selectedFeeDetails.contact_number, "Contact copied")
                            }
                        >
                            {selectedFeeDetails.contact_number} <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20"
                                height="20"><g id="SVGRepo_bgCarrier" strokeWidth="0"
                                > <title>Copy Contact Number</title>
                                </g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.24 2H11.3458C9.58159 1.99999 8.18418 1.99997 7.09054 2.1476C5.96501 2.29953 5.05402 2.61964 4.33559 3.34096C3.61717 4.06227 3.29833 4.97692 3.14701 6.10697C2.99997 7.205 2.99999 8.60802 3 10.3793V16.2169C3 17.725 3.91995 19.0174 5.22717 19.5592C5.15989 18.6498 5.15994 17.3737 5.16 16.312L5.16 11.3976L5.16 11.3024C5.15993 10.0207 5.15986 8.91644 5.27828 8.03211C5.40519 7.08438 5.69139 6.17592 6.4253 5.43906C7.15921 4.70219 8.06404 4.41485 9.00798 4.28743C9.88877 4.16854 10.9887 4.1686 12.2652 4.16867L12.36 4.16868H15.24L15.3348 4.16867C16.6113 4.1686 17.7088 4.16854 18.5896 4.28743C18.0627 2.94779 16.7616 2 15.24 2Z" fill="#7F56DA"></path> <path d="M6.6001 11.3974C6.6001 8.67119 6.6001 7.3081 7.44363 6.46118C8.28716 5.61426 9.64481 5.61426 12.3601 5.61426H15.2401C17.9554 5.61426 19.313 5.61426 20.1566 6.46118C21.0001 7.3081 21.0001 8.6712 21.0001 11.3974V16.2167C21.0001 18.9429 21.0001 20.306 20.1566 21.1529C19.313 21.9998 17.9554 21.9998 15.2401 21.9998H12.3601C9.64481 21.9998 8.28716 21.9998 7.44363 21.1529C6.6001 20.306 6.6001 18.9429 6.6001 16.2167V11.3974Z" fill="#7F56DA"
                                ></path> </g></svg>
                        </span>
                    </h2>


                    <button className="close-btn" onClick={handleClose}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                {/* TABS — fixed, never scrolls */}
                <div style={{ flexShrink: 0, padding: "0 20px", background: "#fff" }}>
                    <ul className="nav nav-tabs justify-content-end feetab" style={{ borderBottom: "none", marginBottom: 0 }}>
                        <li className="nav-item">
                            <button className={`nav-link ${viewMode === "ledger" ? "active" : ""}`} onClick={() => setViewMode("ledger")}>
                                Ledger Details
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${viewMode === "scheduled" ? "active" : ""}`} onClick={() => setViewMode("scheduled")}>
                                Scheduled Fee
                            </button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${viewMode === "plan" ? "active" : ""}`} onClick={() => setViewMode("plan")}>
                                Imposed Fee
                            </button>
                        </li>
                    </ul>
                </div>

                {/* BODY — scrollable area only */}
                <div style={{ flex: 1, minHeight: 0, overflow: "hidden", padding: "12px 20px", display: "flex", flexDirection: "column" }}>
                    <div className="ledgerContainer" style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>

                        {viewMode === "ledger" && (
                            <div className="mt-2 paymentreporttablecontainer ledgerWrapper"
                                style={{
                                    border: "1px solid #E9E9E9",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    display: "flex",
                                    flexDirection: "column",
                                    flex: 1,
                                    minHeight: 0,
                                }}>

                                <div style={{ flex: 1, minHeight: 0, overflowY: "auto", scrollbarWidth: "thin", scrollbarColor: "#d1d5db transparent" }}>
                                <table className="table table-sm table-bordered table-hover student-table fee ledgerTable" style={{ marginBottom: 0 }}>

                                    {/* STICKY HEADER */}
                                    <thead className="ledgerHeader" style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                        <tr>
                                            <th>Date</th>
                                            <th>Particular</th>
                                            <th style={{ textAlign: "right" }}>Debit</th>
                                            <th style={{ textAlign: "right" }}>Credit</th>
                                            <th style={{ textAlign: "right" }}>Balance</th>
                                        </tr>
                                    </thead>

                                    {/* SCROLL BODY */}
                                    <tbody className="ledgerBody">
                                        {selectedFeeDetails?.ledger_data?.length > 0 ? (() => {
                                            let runningBalance = 0;

                                            const sortedLedger = [...selectedFeeDetails.ledger_data]
                                                .slice(0, visibleCount)
                                                .map(txn => ({
                                                    ...txn,
                                                    sortDate: txn?.remark?.includes("First Year Fee")
                                                        ? parseDDMMYYYYHHMMSS(txn.due_date)
                                                        : txn.payment_type === "Credit" && txn.payment_date
                                                            ? parseDDMMYYYYHHMMSS(txn.payment_date)
                                                            : parseDDMMYYYYHHMMSS(txn.created_at)
                                                }))
                                                .sort((a, b) => a.sortDate - b.sortDate);

                                            return sortedLedger.map((txn, idx) => {
                                                const isCredit = txn.payment_type === "Credit";
                                                const amount = parseFloat(txn.amount) || 0;
                                                const debit = !isCredit ? amount : 0;
                                                const credit = isCredit ? amount : 0;

                                                runningBalance += credit - debit;

                                                return (
                                                    <tr key={idx}>
                                                        <td>
                                                            {txn?.remark?.includes("First Year Fee")
                                                                ? formatDateDDMMYYYY(parseDDMMYYYYHHMMSS(txn.due_date))
                                                                : isCredit
                                                                    ? txn.payment_date
                                                                        ? formatDateDDMMYYYYHHMMSS_UTC(txn.payment_date)
                                                                        : formatDateDDMMYYYYHHMMSS_UTC(txn.created_at)
                                                                    : txn.due_date
                                                                        ? formatDateDDMMYYYY(parseDDMMYYYYHHMMSS(txn.due_date))
                                                                        : formatDateDDMMYYYYHHMMSS_UTC(txn.created_at)
                                                            }
                                                        </td>
                                                        <td>
                                                            {(() => {
                                                                const { payment_type, status, transaction, mode_of_payment, fee_head, remark, transaction_id } = txn;

                                                                if (payment_type === "Credit") {
                                                                    if (remark && remark.toLowerCase().includes("pet")) {
                                                                        return remark;
                                                                    }
                                                                    if (status !== "Initiated" && !transaction && !mode_of_payment) return "Yet to be reconciled";
                                                                    if (status === "Success") {
                                                                        const mop = mode_of_payment || transaction?.mode_of_payment;
                                                                        if (mop) {
                                                                            switch (mop) {
                                                                                case "Cash": return "Cash";
                                                                                case "Cheque": return transaction?.cheque_number ? `Cheque (No: ${transaction.cheque_number})` : "Cheque";
                                                                                case "RTGS": return transaction?.utr_number ? `RTGS (UTR: ${transaction.utr_number})` : "RTGS";
                                                                                case "DD": return transaction?.dd_number ? `DD (No: ${transaction.dd_number})` : "DD";
                                                                                case "UPI": return txn?.transaction_id ? `UPI (Txn: ${txn.transaction_id})` : "UPI";
                                                                                default: return mop;
                                                                            }
                                                                        }
                                                                    }
                                                                    return fee_head || "N/A";
                                                                }

                                                                if (payment_type === "Debit") {
                                                                    if (!fee_head && !mode_of_payment && !transaction_id && remark) return remark;
                                                                    // Refund debits carry a mode of payment but no fee head,
                                                                    // so without the fallback they render as a bare "N/A".
                                                                    return fee_head || mode_of_payment || "N/A";
                                                                }

                                                                return fee_head || "N/A";
                                                            })()}

                                                            {txn.remark && txn.remark.trim() !== "" && (
                                                                <div style={{ fontSize: "12px", color: "#6c757d", marginTop: "2px", whiteSpace: "normal", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                                                                    {txn.remark}
                                                                </div>
                                                            )}
                                                        </td>

                                                        <td style={{ textAlign: "right" }}> ₹ {debit.toFixed(2)}</td>
                                                        <td style={{ textAlign: "right" }}> ₹ {credit.toFixed(2)}</td>
                                                        <td style={{ textAlign: "right" }}> ₹ {runningBalance.toFixed(2)}</td>
                                                    </tr>
                                                );
                                            });
                                        })() : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                                                    No ledger entries found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                    {/* STICKY FOOTER */}
                                    {selectedFeeDetails?.ledger_data?.length > 0 && (
                                        <tfoot className="ledgerFooter" style={{ position: "sticky", bottom: 0, zIndex: 2 }}>
                                            <tr style={{ fontWeight: "bold" }}>
                                                <td colSpan="2" style={{ textAlign: "left" }}></td>
                                                <td style={{ textAlign: "right" }}>
                                                    ₹ {selectedFeeDetails.ledger_data.slice(0, visibleCount)
                                                        .reduce((s, t) => t.payment_type !== "Credit" ? s + parseFloat(t.amount || 0) : s, 0).toFixed(2)}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    ₹ {selectedFeeDetails.ledger_data.slice(0, visibleCount)
                                                        .reduce((s, t) => t.payment_type === "Credit" ? s + parseFloat(t.amount || 0) : s, 0).toFixed(2)}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    ₹ {selectedFeeDetails.ledger_data.slice(0, visibleCount)
                                                        .reduce((b, t) => { const a = parseFloat(t.amount || 0); return t.payment_type === "Credit" ? b + a : b - a; }, 0).toFixed(2)}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    )}
                                </table>
                                </div>

                                {/* Show More */}
                                {selectedFeeDetails?.ledger_data?.length > visibleCount && (
                                    <div style={{ textAlign: "end", padding: "8px 12px", borderTop: "1px solid #E9E9E9" }}>
                                        <button className="showMoreBtn" onClick={() => setVisibleCount(prev => prev + 50)}>
                                            Show More Payments
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {viewMode === "scheduled" && (
                            <ScheduledFeeShortDetails selectedFeeDetails={selectedFeeDetails} />
                        )}

                        {viewMode === "plan" && (
                            <FeePlanShortDetails selectedFeeDetails={selectedFeeDetails} />
                        )}
                    </div>
                </div>

                {/* FOOTER — fixed, never scrolls */}
                <div style={{
                    flexShrink: 0,
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    padding: "12px 20px",
                    borderTop: "1px solid #E9E9E9",
                    background: "#fff",
                }}>
                    <div style={{ display: "flex", gap: "10px" }}>
                        <button
                            className="add-btn"
                            onClick={() => {
                                if (viewMode === "ledger") downloadLedgerPDF(selectedFeeDetails);
                                else if (viewMode === "scheduled") downloadScheduledPDF(selectedFeeDetails, selectedFeeDetails?.payment_schedule || []);
                                else if (viewMode === "plan") downloadPlanPDF(selectedFeeDetails);
                            }}
                        >
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" height="20" width="20">
                                <g stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 12V18M12 18L15 16M12 18L9 16M13 3.00087C12.9045 3 12.7973 3 12.6747 3H8.2002C7.08009 3 6.51962 3 6.0918 3.21799C5.71547 3.40973 5.40973 3.71547 5.21799 4.0918C5 4.51962 5 5.08009 5 6.2002V17.8002C5 18.9203 5 19.4801 5.21799 19.9079C5.40973 20.2842 5.71547 20.5905 6.0918 20.7822C6.5192 21 7.07899 21 8.19691 21H15.8031C16.921 21 17.48 21 17.9074 20.7822C18.2837 20.5905 18.5905 20.2842 18.7822 19.9079C19 19.4805 19 18.9215 19 17.8036V9.32568C19 9.20296 19 9.09561 18.9991 9M13 3.00087C13.2856 3.00347 13.4663 3.01385 13.6388 3.05526C13.8429 3.10425 14.0379 3.18526 14.2168 3.29492C14.4186 3.41857 14.5918 3.59182 14.9375 3.9375L18.063 7.06298C18.4089 7.40889 18.5809 7.58136 18.7046 7.78319C18.8142 7.96214 18.8953 8.15726 18.9443 8.36133C18.9857 8.53376 18.9963 8.71451 18.9991 9M13 3.00087V5.8C13 6.9201 13 7.47977 13.218 7.90759C13.4097 8.28392 13.7155 8.59048 14.0918 8.78223C14.5192 9 15.079 9 16.1969 9H18.9991M18.9991 9H19.0002" />
                                </g>
                            </svg>
                            Download PDF
                        </button>
                        <button
                            onClick={() => {
                                if (viewMode === "ledger") printLedger(selectedFeeDetails);
                                else if (viewMode === "scheduled") printScheduledFee(selectedFeeDetails, selectedFeeDetails.payment_schedule || []);
                                else if (viewMode === "plan") printPlan(selectedFeeDetails);
                            }}
                        >
                            <img src={print} alt="print" style={{ marginRight: '8px' }} />
                            Print
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};
